/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISampleContainerType } from 'app/shared/model/sample-container-type.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';

export interface ISampleContainerTestSample {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  container?: ISampleContainerType | null;
  testItem?: ILabTestItem | null;
}

export const defaultValue: Readonly<ISampleContainerTestSample> = {
  active: false,
};
